import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { Field, reduxForm } from 'redux-form';
import { renderField } from '../../../form_helpers';
import { isCompetition } from '../../../helpers';
import validate from './SignUpFormValidate';
import { EMAIL_REGEX } from '../../../constants';
import { checkEmailAddress, clearCheckEmailAddress } from '../../../actions';
import { connect } from 'react-redux';
import { Button as ButtonV2 } from '../../../v2/components/button/Button';

const asyncValidate = (values, dispatch, props) => {
  // test it looks email like and is not .cymru
  if (
    EMAIL_REGEX.test(values.email) &&
    values.email.toLowerCase().split('.').reverse()[0] !== 'cymru'
  ) {
    return dispatch(checkEmailAddress(values.email));
  }
  return new Promise((resolve, reject) => {
    resolve('No check run');
  });
};

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.handleEmailSuggest = this.handleEmailSuggest.bind(this);
  }

  handleEmailSuggest = (email) => {
    this.props.change('email', email);
    this.props.change('email_confirm', '');
    this.props.clearCheckEmailAddress();
  };

  componentWillUnmount = () => {
    this.props.clearCheckEmailAddress();
  };

  getSuggestedEmail = (emailCheck) => {
    // split the suggestion to workout which part is different
    if (EMAIL_REGEX.test(emailCheck.did_you_mean)) {
      // test its an email
      let didYouMean = emailCheck.did_you_mean.split('@');
      let original = emailCheck.email.split('@');
      let emailToDisplay = [];
      for (var i = 0; i < didYouMean.length; i++) {
        if (didYouMean[i] === original[i]) {
          emailToDisplay.push(didYouMean[i]);
        } else {
          emailToDisplay.push(
            "<span class='suggest'>" + didYouMean[i] + '</span>'
          );
        }
      }
      return emailToDisplay.join('@');
    }
    return null;
  };

  render() {
    const strings = this.props.strings;
    const { handleSubmit, submitting, pristine, emailCheck } = this.props;

    const suggestAlternateEmail = emailCheck && emailCheck.did_you_mean;

    return (
      <div className="form form--no-btm-pad">
        <header className="form__header">
          <FormInstruct>{strings.registerInstruction}</FormInstruct>
        </header>
        <form className="form__form" onSubmit={handleSubmit}>
          <Field
            name="person_name"
            type="text"
            component={renderField}
            placeholder={strings.firstOrFullName}
            label={strings.yourName}
            autoFocus={true}
          />
          <Field
            name="email"
            type="email"
            component={renderField}
            placeholder={strings.email}
            label={strings.email}
          />
          {suggestAlternateEmail && this.getSuggestedEmail(emailCheck) && (
            <div role="alert" className="form__suggestion">
              <button
                className="form__suggest link"
                type="button"
                dangerouslySetInnerHTML={{
                  __html: `<span class="suggest__msg">${
                    strings.didYouMean
                  } </span> <span class="suggest__email">${this.getSuggestedEmail(
                    emailCheck
                  )}?</span>`,
                }}
                onClick={() => this.handleEmailSuggest(emailCheck.did_you_mean)}
              />
            </div>
          )}
          <Field
            name="email_confirm"
            type="email"
            component={renderField}
            placeholder={strings.emailConfirm}
            label={strings.emailConfirm}
          />

          <Field
            name="password"
            type="password"
            component={renderField}
            placeholder={strings.password}
            label={strings.password}
          />

          {this.props.children}

          {isCompetition() && (
            <div
              className="form__comp"
              dangerouslySetInnerHTML={{ __html: strings.competitionMessage }}
            ></div>
          )}

          <div className="form__actions">
            <ButtonV2
              onClick={handleSubmit}
              label={strings.next}
              size="large"
              disabled={pristine || submitting}
            />
            <ButtonSubmit aria-hidden="true" />
          </div>
        </form>
      </div>
    );
  }
}

const FormInstruct = styled.div`
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull};
  font-size: 20px;
  line-height: 24px;
`;

const ButtonSubmit = styled.button`
  position: absolute;
  left: -9999px;
`;

SignUpForm = reduxForm({
  form: 'signup',
  destroyOnUnmount: false,
  enableReinitialize: true,
  validate,
  asyncValidate,
  asyncBlurFields: ['email'],
})(SignUpForm);

SignUpForm = connect(
  (state) => ({
    emailCheck: state.emailCheck.success,
  }),
  { clearCheckEmailAddress }
)(SignUpForm);

export default SignUpForm;
